import React from 'react';
import styles from './SilentPicker.module.scss';

interface PickerSectionHeaderProps {
  label: string;
}

export function PickerSectionHeader({ label }: PickerSectionHeaderProps) {
  return (
    <li
      className={styles['spectrum-picker-section-header']}
      role="presentation"
    >
      <span className={styles['spectrum-picker-section-title']}>{label}</span>
    </li>
  );
}
